import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

console.log('Application starting...');
console.log('Environment:', process.env.NODE_ENV);
console.log('Firebase Project ID:', process.env.REACT_APP_FIREBASE_PROJECT_ID);

try {
  const root = createRoot(document.getElementById('root'));
  root.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
  console.log('Application rendered successfully');
} catch (error) {
  console.error('Error rendering application:', error);
  // Show a basic error message
  document.body.innerHTML = `
    <div style="padding: 20px; margin: 20px; border: 1px solid #f5c6cb; border-radius: 4px; background-color: #f8d7da; color: #721c24;">
      <h1>Something went wrong</h1>
      <p>The application encountered an error. Please try refreshing the page.</p>
      <p>Error: ${error.message}</p>
    </div>
  `;
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
